import DOMPurify from 'dompurify'

const SANITIZE_OPTIONS = {
    USE_PROFILES: { html: true },
}

export const sanitizeHtml = (rawHtml = '') => {
    if (typeof rawHtml !== 'string' || !rawHtml) {
        return ''
    }

    return DOMPurify.sanitize(rawHtml, SANITIZE_OPTIONS)
}
